import { OutstandingUserTicketsSummaryDto } from 'api/Tickets/Types/OutstandingUserTicketsSummaryDto'

export enum NotificationType {
  OUTSTANDING_TICKETS = 'outstanding_tickets_summary',
}
export interface NotificationMessage {
  type: 'outstanding_tickets_summary'
  timestamp: number
  data: OutstandingUserTicketsSummaryDto[]
}
